export const buttonCustomizations = {
  MuiButton: {
    defaultProps: {
      variant: "contained",  
      size: "medium",
      disableElevation: true,
      fullWidth: false,
    },
    styleOverrides: {
      root: {
        borderRadius: 6,
        textTransform: "none",
        fontWeight: 500,
        fontSize: "0.9rem",
        padding: "6px 16px",
        transition: "all 0.2s ease-in-out",
      },
      outlined: {
        borderColor: "#003B7A",
        color: "#003B7A",
        backgroundColor: (theme) => theme.palette.background.paper,
        "&:hover": {
          backgroundColor: "rgba(0, 59, 122, 0.05)",
          borderColor: "#003B7A",
        },
      },
      contained: {
        backgroundColor: "#003B7A",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#002e5a",
        },
      },
    },
  },
};
